/**
 * Formatting for a member's last app engagement.
 *
 * Extracted from `CareCoordinationPill` in round 7, when Last Engaged became
 * its own roster column. Two things now render this date — the column and the
 * pill's "Last Engaged · Aug 10" label — and a member's engagement date must
 * read identically in both. Same reasoning as `isRecentSignup` being shared
 * with the "New This Week" stat: one definition, so there's nothing to drift.
 */

/** "Aug 10" — short enough to sit inside a pill next to its label. */
export const ENGAGED_DATE = new Intl.DateTimeFormat(undefined, {
  month: 'short',
  day: 'numeric',
});

/** The same date spelled out, for tooltips and screen readers. */
export const ENGAGED_DATE_LONG = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'long',
});

/**
 * Parse an engagement timestamp, or `null` if there isn't a usable one.
 *
 * A member who has never logged in has no engagement date at all, and that is
 * a real state rather than missing data — callers render it as blank rather
 * than as a dash or a placeholder. Malformed values collapse to the same
 * `null` so a bad timestamp can't reach a formatter and print "Invalid Date".
 */
export const parseEngagedAt = (lastEngagedAt?: string): Date | null => {
  if (!lastEngagedAt) return null;

  const date = new Date(lastEngagedAt);
  return Number.isNaN(date.getTime()) ? null : date;
};
